import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { PencilIcon, MapPinIcon, StarIcon, ArrowLeftIcon, CalendarIcon, ClockIcon, CheckIcon, XIcon, BookIcon, LayersIcon, PaletteIcon } from 'lucide-react';
import BackButton from '../../components/UI/BackButton';
// Mock data - in a real app, this would come from an API
interface PortfolioItem {
  id: number;
  imageUrl: string;
  title: string;
  category: string;
  client?: string;
  bookId?: string;
  description?: string;
  date: string;
  styles: string[];
}
interface ContentUsage {
  id: number;
  imageUrl: string;
  title: string;
  type: 'book' | 'merchandise';
  author: string;
  authorId: string;
  bookId?: string;
  productId?: string;
  releaseDate: string;
  genre: string;
  series?: {
    name: string;
    position: number;
  };
  photographer?: {
    name: string;
    id: string;
  };
}
const designersData = [{
  id: 1,
  name: 'Alex Thompson',
  location: 'Seattle, WA',
  specialties: ['Romance', 'Fantasy', 'Young Adult'],
  rating: 4.9,
  reviewCount: 156,
  imageUrl: 'https://images.unsplash.com/photo-1619539465730-fea9f161d269',
  availability: 'Available Now',
  priceRange: '$300-800',
  completedCovers: 245,
  bio: 'Award-winning book cover designer with over 10 years of experience working with both indie authors and major publishing houses. Specializing in genre fiction with a focus on creating covers that capture the essence of your story while standing out in the marketplace.',
  tools: ['Adobe Photoshop', 'Adobe Illustrator', 'Procreate'],
  experience: '10 years',
  education: 'MFA in Graphic Design, Rhode Island School of Design',
  languages: ['English', 'Spanish'],
  designStyles: ['Photographic', 'Illustrated', 'Typography-focused', 'Minimalist'],
  bookings: [{
    month: 'June',
    availability: 'Limited'
  }, {
    month: 'July',
    availability: 'Available'
  }, {
    month: 'August',
    availability: 'Available'
  }],
  portfolio: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1614728263952-84ea256f9679',
    title: 'Starfall',
    category: 'Fantasy',
    client: 'Amara Knight',
    bookId: 'starfall',
    description: 'Award-winning cover design for bestselling fantasy novel',
    date: '2023-03-15',
    styles: ['Photographic', 'Digital Painting']
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f',
    title: 'The Silent Echo',
    category: 'Mystery Thriller',
    client: 'Elena Richards',
    bookId: 'the-silent-echo',
    description: 'Atmospheric thriller cover with custom typography',
    date: '2023-02-20',
    styles: ['Photographic', 'Typography-focused']
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1633477189729-9290b3261d0a',
    title: 'The Broken Echo',
    category: 'Mystery Thriller',
    client: 'Elena Richards',
    bookId: 'the-broken-echo',
    description: 'Sequel design maintaining series branding',
    date: '2023-04-05',
    styles: ['Photographic', 'Typography-focused', 'Series Design']
  }, {
    id: 4,
    imageUrl: 'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf',
    title: 'Whispers in the Dark',
    category: 'Horror',
    client: 'Maya Rodriguez',
    bookId: 'whispers-in-the-dark',
    description: 'Horror novel with custom illustration',
    date: '2023-01-10',
    styles: ['Illustrated', 'Dark Theme']
  }, {
    id: 5,
    imageUrl: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e',
    title: 'Beyond the Veil',
    category: 'Paranormal Romance',
    client: 'Marcus Chen',
    bookId: 'beyond-the-veil',
    description: 'Paranormal romance with custom typography',
    date: '2023-05-22',
    styles: ['Photographic', 'Typography-focused']
  }, {
    id: 6,
    imageUrl: 'https://images.unsplash.com/photo-1474552226712-ac0f0961a954',
    title: 'Hearts Entwined',
    category: 'Romance',
    client: 'Sarah Johnson',
    bookId: 'hearts-entwined',
    description: 'Contemporary romance with minimalist design',
    date: '2023-03-30',
    styles: ['Minimalist', 'Typography-focused']
  }],
  contentUsage: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1614728263952-84ea256f9679',
    title: 'Starfall',
    type: 'book',
    author: 'Amara Knight',
    authorId: 'amara-knight',
    bookId: 'starfall',
    releaseDate: '2023-04-15',
    genre: 'Fantasy',
    photographer: {
      name: 'Sarah Chen',
      id: '1'
    }
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f',
    title: 'The Silent Echo',
    type: 'book',
    author: 'Elena Richards',
    authorId: 'elena-richards',
    bookId: 'the-silent-echo',
    releaseDate: '2023-03-10',
    genre: 'Mystery',
    series: {
      name: 'Echo Series',
      position: 1
    }
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1633477189729-9290b3261d0a',
    title: 'The Broken Echo',
    type: 'book',
    author: 'Elena Richards',
    authorId: 'elena-richards',
    bookId: 'the-broken-echo',
    releaseDate: '2023-05-20',
    genre: 'Mystery',
    series: {
      name: 'Echo Series',
      position: 2
    }
  }],
  reviews: [{
    id: 1,
    author: 'Elena Richards',
    authorRole: 'Mystery Author',
    rating: 5,
    comment: 'Alex created a stunning series design for my Echo books that perfectly captured the mood and theme. The covers have been consistently mentioned by readers as what drew them to the books initially. Professional, responsive, and incredibly talented!',
    date: '2023-05-25'
  }, {
    id: 2,
    author: 'Amara Knight',
    authorRole: 'Fantasy Author',
    rating: 5,
    comment: 'My cover for "Starfall" won a design award and has significantly boosted my book, s, visibility, : .Alex, took, the, time, to, understand, my, story, and, created, a, cover, that, stands, while: perfectly, representing, the, content, : .Worth, every, penny, \',: date, \'2023-04-20'
  }, {
    id: 3,
    author: 'Marcus Chen',
    authorRole: 'Romance Author',
    rating: 4,
    comment: 'Great work on my paranormal romance cover. Alex has a real talent for typography and creating the right mood for genre fiction. The process was smooth and the revisions were handled professionally.',
    date: '2023-05-30'
  }]
}
// More designers could be added here
];
const DesignerPortfolio = () => {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const [activeTab, setActiveTab] = useState<'portfolio' | 'reviews' | 'booking' | 'content'>('portfolio');
  // Find the designer based on the ID from the URL
  const designer = designersData.find(d => d.id === parseInt(id || '0'));
  if (!designer) {
    return <div className="min-h-screen bg-gray-50 py-8 px-4" data-id="element-15131" data-mp="3vdwimijmexjh">
        <div className="max-w-7xl mx-auto text-center" data-id="element-15132" data-mp="392cedal98a0">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-15133" data-mp="37hi8os6rrco">
            Designer Not Found
          </h1>
          <p className="text-lg text-gray-600 mb-8" data-id="element-15134" data-mp="8126hp3z96yo">
            The designer you're looking for doesn't exist or has been removed.
          </p>
          <Link to="/talent/designers" className="inline-flex items-center bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors" data-id="element-15135" data-mp="3bolzsvokvwh5">
            <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-15136" data-mp="202owcv8uce30" />
            Back to Designers
          </Link>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-15137" data-mp="2f1ak6sszw01g">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15138" data-mp="2a0w911w3k9z7">
        {/* Back Button */}
        <div className="mb-6" data-id="element-15139" data-mp="2o0e39ws5wffy">
          <BackButton data-id="element-15140" data-mp="2nzcg4txvg2hv" />
        </div>
        {/* Designer Header */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-8" data-id="element-15141" data-mp="2j1kpe38yqmf9">
          <div className="md:flex" data-id="element-15142" data-mp="2iz87fq37gc27">
            <div className="md:w-1/3" data-id="element-15143" data-mp="2xqql3h8lduie">
              <img src={designer.imageUrl} alt={designer.name} className="w-full h-96 object-cover" data-id="element-15144" data-mp="2xpntf73g3o1f" />
            </div>
            <div className="p-6 md:w-2/3" data-id="element-15145" data-mp="36rosm9i8ok5q">
              <div className="flex justify-between items-start" data-id="element-15146" data-mp="36oj1koq1v87d">
                <div data-id="element-15147" data-mp="32qv3xdwz31bs">
                  <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-15148" data-mp="32n7byj76emz6">
                    {designer.name}
                  </h1>
                  <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-15149" data-mp="3qcfbyyhqr0on">
                    <MapPinIcon className="h-4 w-4 mr-1" data-id="element-15150" data-mp="3ccwdyyin95q2" />
                    {designer.location}
                  </div>
                </div>
                <div className="flex items-center bg-yellow-50 px-3 py-1 rounded-full" data-id="element-15151" data-mp="3haxxtlnw992l">
                  <StarIcon className="h-5 w-5 text-yellow-400 mr-1" data-id="element-15152" data-mp="32mulzvn6735v" />
                  <span className="font-medium text-gray-900" data-id="element-15153" data-mp="37dt9pgahn3j5">
                    {designer.rating}
                  </span>
                  <span className="text-gray-500 ml-1" data-id="element-15154" data-mp="2tn7mjfe047fg">
                    ({designer.reviewCount} reviews)
                  </span>
                </div>
              </div>
              <div className="mb-6" data-id="element-15155" data-mp="2joie0d7zvzbv">
                <h2 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-15156" data-mp="2jpa1t1vcosrl">
                  About
                </h2>
                <p className="text-gray-600" data-id="element-15157" data-mp="2oms6gg2c4lts">{designer.bio}</p>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-15158" data-mp="9tey4ssjtcv5">
                <div data-id="element-15159" data-mp="dwbbo538eis8">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-15160" data-mp="dwl1nsoa0pxx">
                    Experience
                  </h3>
                  <p className="text-gray-900" data-id="element-15161" data-mp="3w39398k4auyu">{designer.experience}</p>
                </div>
                <div data-id="element-15162" data-mp="4vdfg8z1bfk7">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-15163" data-mp="4wy8tv9m4sgh">
                    Completed Covers
                  </h3>
                  <p className="text-gray-900" data-id="element-15164" data-mp="xkaix5yl77sw">{designer.completedCovers}</p>
                </div>
                <div data-id="element-15165" data-mp="iveh3qn4ir0q">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-15166" data-mp="ituvdkip7nrk">
                    Price Range
                  </h3>
                  <p className="text-gray-900" data-id="element-15167" data-mp="ns4vm9ja5ek1">{designer.priceRange}</p>
                </div>
                <div data-id="element-15168" data-mp="1bhz8us7ih54t">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-15169" data-mp="1bhqs2p89pfoc">
                    Availability
                  </h3>
                  <p className="text-green-600" data-id="element-15170" data-mp="310fm07mr0trr">{designer.availability}</p>
                </div>
              </div>
              <div className="mb-6" data-id="element-15171" data-mp="2w2e2xmpbouga">
                <h2 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-15172" data-mp="2w1cf0hn7kdh5">
                  Specialties
                </h2>
                <div className="flex flex-wrap gap-2" data-id="element-15173" data-mp="39uu0w93da2ac">
                  {designer.specialties.map(specialty => <span key={specialty} className="px-3 py-1 bg-purple-100 text-purple-700 text-sm rounded-full" data-id="element-15174" data-mp="2i1juj429ythm">
                      {specialty}
                    </span>)}
                </div>
              </div>
              <div className="flex gap-4" data-id="element-15175" data-mp="2m2wyt9ppyomf">
                <button className="px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors w-full md:w-auto" data-id="element-15176" data-mp="2m1vcg9396fpe">
                  Request a Quote
                </button>
                <button className="px-4 py-3 border border-purple-600 text-purple-600 rounded-lg hover:bg-purple-50 transition-colors w-full md:w-auto" data-id="element-15177" data-mp="1co03aft24d2">
                  Save to Favorites
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Tabs */}
        <div className="mb-6 border-b border-gray-200" data-id="element-15178" data-mp="346df4t01p9ps">
          <nav className="flex space-x-8" data-id="element-15179" data-mp="395go2oj5c031">
            <button onClick={() => setActiveTab('portfolio')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'portfolio' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-15180" data-mp="394f0xlouvn4y">
              Portfolio
            </button>
            <button onClick={() => setActiveTab('content')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'content' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-15181" data-mp="2q5t087x93y1k">
              Published Works
            </button>
            <button onClick={() => setActiveTab('reviews')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'reviews' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-15182" data-mp="1q5heptwt85st">
              Reviews ({designer.reviews.length})
            </button>
            <button onClick={() => setActiveTab('booking')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'booking' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-15183" data-mp="178g5ty04xljl">
              Availability
            </button>
          </nav>
        </div>
        {/* Tab Content */}
        {activeTab === 'portfolio' && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-id="element-15184" data-mp="oiq2gmib3rg2">
            {designer.portfolio.map(item => <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden group hover:-translate-y-1 transition-transform duration-200" data-id="element-15185" data-mp="2jlcx9v5us3nk">
                <div className="relative aspect-[2/3]" data-id="element-15186" data-mp="29th0qojf0llg">
                  <img src={item.imageUrl} alt={item.title} className="w-full h-full object-cover" data-id="element-15187" data-mp="2et3fj2ew69wd" />

                  <div className="absolute top-2 right-2" data-id="element-15188" data-mp="1zyfatqhbffht">
                    <div className="bg-white/80 text-xs font-medium px-2 py-1 rounded" data-id="element-15189" data-mp="24vyoao66vo8p">
                      {new Date(item.date).toLocaleDateString('en-US', {
                  month: 'short',
                  year: 'numeric'
                })}
                    </div>
                  </div>
                </div>
                <div className="p-4" data-id="element-15190" data-mp="3l7kv3vtx0br1">
                  <h3 className="font-medium text-gray-900 mb-1" data-id="element-15191" data-mp="3q8s1prkbn4w4">
                    {item.title}
                  </h3>
                  <div className="flex flex-wrap gap-1 mb-3" data-id="element-15192" data-mp="47ubv5gq3h15">
                    <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full" data-id="element-15193" data-mp="3vdvtjwv718vr">
                      {item.category}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-1 mb-3" data-id="element-15194" data-mp="88wg60phyj9z">
                    <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full" data-id="element-15195" data-mp="87d0ocbo0c99">
                      Author
                    </span>
                    {item.client && <Link to={`/author/${item.client.toLowerCase().replace(/\s+/g, '-')}`} className="text-xs px-2 py-0.5 bg-purple-100 text-purple-600 rounded-full hover:bg-purple-200" data-id="element-15196" data-mp="hxxy3wflraql">
                        {item.client}
                      </Link>}
                  </div>
                  {item.description && <p className="text-sm text-gray-600 mb-2" data-id="element-15197" data-mp="2tq370n7i0c2c">
                      {item.description}
                    </p>}
                  <div className="flex flex-wrap gap-1 mt-2 mb-3" data-id="element-15198" data-mp="11lnpura4qx7q">
                    {item.styles.map((style, idx) => <span key={idx} className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full" data-id="element-15199" data-mp="16kqsk52n0rcj" data-mpi={idx}>
                        {style}
                      </span>)}
                  </div>
                  {item.bookId && <div className="mt-2" data-id="element-15200" data-mp="1kj8djv15rpqr">
                      <Link to={`/book/${item.bookId}`} className="text-xs flex items-center text-purple-600 hover:text-purple-800" data-id="element-15201" data-mp="1pbi49da3ktu3">
                        <BookIcon className="h-3 w-3 mr-1" data-id="element-15202" data-mp="1zb0jxhiz5tgc" />
                        View Book
                      </Link>
                    </div>}
                </div>
              </div>)}
          </div>}
        {activeTab === 'content' && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-id="element-15203" data-mp="3jrqj2efs7iyf">
            {designer.contentUsage.map(item => <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:-translate-y-1 transition-transform duration-200" data-id="element-15204" data-mp="3ev9ksrevbo7m">
                <Link to={item.type === 'book' ? `/book/${item.bookId}` : `/product/${item.productId}`} className="block" data-id="element-15205" data-mp="bej7drgyi8vw">
                  <div className="relative aspect-[2/3]" data-id="element-15206" data-mp="3srwu7to0c6uf">
                    <img src={item.imageUrl} alt={item.title} className="w-full h-full object-cover" data-id="element-15207" data-mp="u2xzki30fsya" />

                    {item.series && <div className="absolute top-2 left-0" data-id="element-15208" data-mp="3ttsiku5znooz">
                        <div className="bg-purple-600 text-white text-xs font-bold px-2 py-1 rounded-r" data-id="element-15209" data-mp="2fd253rvms5l">
                          {item.series.name} #{item.series.position}
                        </div>
                      </div>}
                    <div className="absolute bottom-2 right-2" data-id="element-15210" data-mp="3ovr28gzy63h7">
                      <div className="bg-amber-100 text-amber-800 text-xs font-medium px-2 py-1 rounded-full" data-id="element-15211" data-mp="gfe5cpvm6bo8">
                        {new Date(item.releaseDate).getFullYear()}
                      </div>
                    </div>
                  </div>
                  <div className="p-4" data-id="element-15212" data-mp="7e6ir52gmz9z">
                    <h3 className="font-medium text-gray-900 mb-1" data-id="element-15213" data-mp="cdapzq5tqmxo">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-2 mb-2" data-id="element-15214" data-mp="2s3ng1cw3irl5">
                      <Link to={`/author/${item.authorId}`} className="text-sm text-purple-600 hover:text-purple-800" data-id="element-15215" data-mp="2x3i9no799v9w">
                        {item.author}
                      </Link>
                      <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full" data-id="element-15216" data-mp="2kkwdfa7vopi9">
                        {item.genre}
                      </span>
                    </div>
                    {item.photographer && <div className="text-xs text-gray-500" data-id="element-15217" data-mp="25w07bipdtmka">
                        Photography by{' '}
                        <Link to={`/talent/photographers/${item.photographer.id}/portfolio`} className="text-purple-600 hover:text-purple-800" data-id="element-15218" data-mp="20xggp4zufmll">
                          {item.photographer.name}
                        </Link>
                      </div>}
                  </div>
                </Link>
              </div>)}
          </div>}
        {activeTab === 'reviews' && <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-15219" data-mp="em9dyavy5150">
            <div className="p-6" data-id="element-15220" data-mp="ekep4lhk0ovn">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-15221" data-mp="9ny3bxxtumlq">
                Client Reviews
              </h2>
              <div className="space-y-6" data-id="element-15222" data-mp="odds58dsshys">
                {designer.reviews.map(review => <div key={review.id} className="border-b border-gray-100 pb-6 last:border-b-0 last:pb-0" data-id="element-15223" data-mp="jkkoyoxz9hot">
                    <div className="flex justify-between mb-2" data-id="element-15224" data-mp="se63c768cwxp">
                      <div data-id="element-15225" data-mp="sdo0grp2bkgt">
                        <h3 className="font-medium text-gray-900" data-id="element-15226" data-mp="17b6i7a3boxer">
                          {review.author}
                        </h3>
                        <p className="text-sm text-gray-500" data-id="element-15227" data-mp="12d5473kr7oa5">
                          {review.authorRole}
                        </p>
                      </div>
                      <div className="flex items-center" data-id="element-15228" data-mp="343gksmgp3d6j">
                        {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < review.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} data-id="element-15229" data-mp="1jkw9p0qlh5wi" data-mpi={i} />)}
                      </div>
                    </div>
                    <p className="text-gray-600 mb-2" data-id="element-15230" data-mp="1eu601bb4ygw0">{review.comment}</p>
                    <p className="text-sm text-gray-500" data-id="element-15231" data-mp="10uxzof38l2q8">{review.date}</p>
                  </div>)}
              </div>
            </div>
          </div>}
        {activeTab === 'booking' && <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-15232" data-mp="qx0gi608hw4h">
            <div className="p-6" data-id="element-15233" data-mp="qz3f3efgcxkt">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-15234" data-mp="vv1vofujhbao">
                Booking Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-15235" data-mp="2lc2xtgf4q7wb">
                <div data-id="element-15236" data-mp="2qa4i24oakd9d">
                  <h3 className="font-medium text-gray-900 mb-4" data-id="element-15237" data-mp="2q8jooidpr0d3">
                    Design Tools
                  </h3>
                  <div className="flex flex-wrap gap-2 mb-6" data-id="element-15238" data-mp="2ou0cwqttgx6u">
                    {designer.tools.map(tool => <span key={tool} className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full" data-id="element-15239" data-mp="2jvywyerotdzl">
                        {tool}
                      </span>)}
                  </div>
                </div>
                <div data-id="element-15240" data-mp="32k3vn7thm8rj">
                  <h3 className="font-medium text-gray-900 mb-4" data-id="element-15241" data-mp="32jkfnwnedug5">
                    Design Styles
                  </h3>
                  <div className="flex flex-wrap gap-2 mb-6" data-id="element-15242" data-mp="2xs2og0b6f88d">
                    {designer.designStyles.map(style => <span key={style} className="px-3 py-1 bg-purple-100 text-purple-700 text-sm rounded-full" data-id="element-15243" data-mp="2su0v8mk1dsj6">
                        {style}
                      </span>)}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-15244" data-mp="1ntcy5d26v34">
                {designer.bookings.map(booking => <div key={booking.month} className="border rounded-lg p-4" data-id="element-15245" data-mp="6mmss4ftiy6g">
                    <div className="flex items-center justify-between mb-4" data-id="element-15246" data-mp="blpsd9d14c71">
                      <div className="flex items-center" data-id="element-15247" data-mp="bjmrtve930o2">
                        <CalendarIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-15248" data-mp="gkart6kgiruf" />
                        <h3 className="font-medium text-gray-900" data-id="element-15249" data-mp="klvyga6ee9w6">
                          {booking.month}
                        </h3>
                      </div>
                      {booking.availability === 'Available' ? <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-15250" data-mp="ubyyuvfumq4j">
                          Available
                        </span> : booking.availability === 'Limited' ? <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full" data-id="element-15251" data-mp="2121tibni2fca">
                          Limited
                        </span> : <span className="px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full" data-id="element-15252" data-mp="2arv3x9bwooey">
                          Booked
                        </span>}
                    </div>
                    <div className="space-y-2" data-id="element-15253" data-mp="1i2xl953s8plo">
                      <div className="flex items-center" data-id="element-15254" data-mp="1i3pi0j948tdj">
                        {booking.availability === 'Available' ? <CheckIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-15255" data-mp="1d6fkshfhjdf5" /> : booking.availability === 'Limited' ? <ClockIcon className="h-4 w-4 text-yellow-500 mr-2" data-id="element-15256" data-mp="1n20pwofuott4" /> : <XIcon className="h-4 w-4 text-red-500 mr-2" data-id="element-15257" data-mp="32hzhop55ud77" />}
                        <span className="text-gray-600" data-id="element-15258" data-mp="2yge2uy92foud">
                          {booking.availability === 'Available' ? 'Open for bookings' : booking.availability === 'Limited' ? 'Some slots available' : 'Fully booked'}
                        </span>
                      </div>
                    </div>
                  </div>)}
              </div>
              <div className="mt-8" data-id="element-15259" data-mp="3or6bqoce0jgp">
                <div className="bg-purple-50 border border-purple-100 rounded-lg p-4 mb-6" data-id="element-15260" data-mp="3ory5ruqc694v">
                  <h3 className="font-medium text-gray-900 mb-2" data-id="element-15261" data-mp="3tpzr6mb8ikji">
                    Design Process
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-15262" data-mp="3ezk1au7viof0">
                    <div className="flex flex-col items-center text-center" data-id="element-15263" data-mp="3jz55bj1whmyl">
                      <div className="bg-purple-100 rounded-full p-3 mb-2" data-id="element-15264" data-mp="bjv5khlhgttz">
                        <PencilIcon className="h-6 w-6 text-purple-700" data-id="element-15265" data-mp="gc653jcbadm0" />
                      </div>
                      <h4 className="font-medium text-gray-900 mb-1" data-id="element-15266" data-mp="q84yu6u86lx6">
                        Concept & Brief
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-15267" data-mp="l91s8hylk7n3">
                        Initial consultation and project brief
                      </p>
                    </div>
                    <div className="flex flex-col items-center text-center" data-id="element-15268" data-mp="c8n3t9qc6cfd">
                      <div className="bg-purple-100 rounded-full p-3 mb-2" data-id="element-15269" data-mp="78ha7o0iafun">
                        <LayersIcon className="h-6 w-6 text-purple-700" data-id="element-15270" data-mp="7alngwkaor7l" />
                      </div>
                      <h4 className="font-medium text-gray-900 mb-1" data-id="element-15271" data-mp="2g7ko93azhsw">
                        Design & Revisions
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-15272" data-mp="3pnjhynybirud">
                        Concept creation with 2 rounds of revisions
                      </p>
                    </div>
                    <div className="flex flex-col items-center text-center" data-id="element-15273" data-mp="3foualp41spsd">
                      <div className="bg-purple-100 rounded-full p-3 mb-2" data-id="element-15274" data-mp="3fqwx3z5zs0sc">
                        <PaletteIcon className="h-6 w-6 text-purple-700" data-id="element-15275" data-mp="1v69yq164ieha" />
                      </div>
                      <h4 className="font-medium text-gray-900 mb-1" data-id="element-15276" data-mp="203rzv5dwfpeq">
                        Final Delivery
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-15277" data-mp="29618fpplx8ph">
                        Full resolution files in multiple formats
                      </p>
                    </div>
                  </div>
                </div>
                <button className="bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors w-full" data-id="element-15278" data-mp="1hebxsdmkfow7">
                  Request a Quote
                </button>
                <p className="text-sm text-gray-500 text-center mt-2" data-id="element-15279" data-mp="1q7yovqftw3z2">
                  Send an enquiry to discuss your project and check detailed
                  availability
                </p>
              </div>
            </div>
          </div>}
      </div>
    </div>;
};
export default DesignerPortfolio;